import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { getSectionsForPath } from "../../data/medicalPageSections";
import { ContactModalProvider } from "../../context/ContactModalContext";
import MedicalNavbar from "../../components/medical/MedicalNavbar";
import StickyContactSidebar from "../../components/medical/StickyContactSidebar";
import MedicalHero from "../../components/medical/MedicalHero";
import HCServices from "../../components/HCServices";
import ExploreMore from "../../components/ExploreMore";
import LeadershipTeam from "../../components/LeadershipTeam";
import Contact from "../../components/Contact";
import ContactModal from "../../components/ContactModal";
import Footer from "../../components/Footer";
import InsightsSection from "../../components/InsightsSection";
import About from "../../components/About";
import ClientWorks from "../../components/ClientWorks";
import HomeContactCTA from "../../components/HomeContactCTA";
import StatsAndLogosMarquee from "../../components/StatsAndLogosMarquee";
import ScrollToTop from "../../components/ScrollToTop";

export default function MedicalLayout() {
  const location = useLocation();
  const isMedicalHome =
    location.pathname === "/medical" || location.pathname === "/medical/";
  const sections = getSectionsForPath(location.pathname);
  const singleSectionWrapperId =
    sections.length === 1 ? sections[0].id : null;
  const isServiceDetailPage = [
    "/medical/suchmethode",
    "/medical/executive-search",
    "/medical/praxisnachfolger-suche",
    "/medical/garantien",
  ].includes(location.pathname);

  return (
    <ContactModalProvider>
      <div data-site="medical" className="min-h-screen bg-bg text-text">
        <MedicalNavbar />
        <StickyContactSidebar sections={sections} />
        <ContactModal />
        <main className="min-h-screen">
        {isMedicalHome && (
          <>
            <div id="section-hero"><MedicalHero /></div>
            <section className="w-full bg-white py-4 md:py-6">
              <div className="container-app">
                <div className="rounded-2xl btn-bg px-5 py-5 shadow-[0_10px_30px_rgba(0,0,0,0.08)] md:px-8 md:py-7">
                  <p className="text-base font-semibold leading-relaxed text-gray-900 md:text-xl">
                    Unsere REPEXO medical feiert in diesem Jahr ihr 40- jähriges Jubiläum. Was gut ist bewährt sich.
                  </p>
                  <p className="mt-3 text-lg font-semibold text-gray-900 md:text-2xl">
                    Weit über 4.000 besetzte Positionen!
                  </p>
                </div>
              </div>
            </section>
            <div id="section-contact-cta"><HomeContactCTA /></div>
            <div id="section-services"><HCServices /></div>
            <div id="section-about"><About /></div>
            <div id="section-cases"><ClientWorks /></div>
            <div id="section-team"><LeadershipTeam /></div>
            <div id="section-insights"><InsightsSection /></div>
            <div id="section-stats-logos"><StatsAndLogosMarquee site="medical" /></div>
            <div id="section-explore"><ExploreMore /></div>
          </>
        )}
        {singleSectionWrapperId ? (
          <div id={singleSectionWrapperId}>
            <Outlet />
          </div>
        ) : (
          <Outlet />
        )}
        {isMedicalHome && <Contact />}
        {!isServiceDetailPage && <Footer />}
        </main>
        <ScrollToTop />
      </div>
    </ContactModalProvider>
  );
}
